import axios from "axios";
import {
  FETCH_SERVICIOS_REQUEST,
  FETCH_SERVICIOS_SUCCESS,
  FETCH_SERVICIOS_FAILURE,
} from "./types";
import { PATH } from "../../utils";

const api = axios.create({
  baseURL: PATH,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const actionServiciosGet = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_SERVICIOS_REQUEST });
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
    const res = await api.get("/servicios", { headers: authHeader(), params: cleanParams });
    const items = Array.isArray(res.data) ? res.data : res.data?.items ?? [];
    dispatch({ type: FETCH_SERVICIOS_SUCCESS, payload: items });
  } catch (err) {
    const msg = err?.response?.data?.detail || err.message || "Error al cargar servicios";
    dispatch({ type: FETCH_SERVICIOS_FAILURE, payload: { error: msg } });
  }
};

export const apiServiciosInstance = api;
export { authHeader as authHeaderServicios };
